



















































import Vue from 'vue';
import NOC from '@/class/common/const';
export default Vue.extend({
  name: 'HelpList',
  data() {
    return {
      qafList: [
        {
          title: 'リモラボの使い方',
          items: [
            {
              thumbnail: [
                {
                  caption: 'インストール方法やユーザーの紐付けなど、\n初期設定の詳しい手順を動画でご紹介しております。\n下記URLからご覧いただけますので、ぜひご活用ください。',
                  link:  '/service/manual/',
                },
              ],
              subTitle: 'マニュアル動画',
              url: 'manual',
            },
            {
              thumbnail: [
                {
                  // REMOLABO-402 暫定表示
                  caption: 'トップバーのユーザー名の右にある矢印をクリックします。',
                  // caption: 'トップバーのユーザー名の右にある矢印をクリックし「ご契約情報」画面を表示します。',
                  // src: '/images/help/01_01.png',
                },
                {
                  caption: 'ご契約情報をクリックし、右側からクライアントツールをダウンロードします。',
                  src: '/images/help/01_02.png',
                },
                {
                  caption: '対象のパソコンでダウンロードしたファイルを解凍します。\nWindows版：setup.exeを実行しインストールします。\nMac版：RemoLabo.pkgをクリックし、画面に従ってインストールします。',
                },
              ],
              subTitle: '１．クライアントツールのダウンロード・インストール',
              url: 'down',
            },
             {
              thumbnail: [
                {
                  caption: 'RemoLabo はコンピュータの利用履歴を記録するため、次回ログイン時にアクセス許可の要求ダイアログが表示されます。\nインストールの完了後、以下の手順でアクセス許可を行ってください。',
                },
                {
                  caption: '【手順】\n1. インストーラの案内に従ってコンピュータを再起動します。\n2. ログイン時に以下の2種類のダイアログが同時に表示されます。',
                },
                {
                  caption: '・“System Events”に対するアクセス要求 \n※同じコンピュータで他のユーザーがログインする際にも表示されます。\n下記のダイアログが表示されたら、OKボタンをクリックしてください。',
                  src: '/images/help/mac01/1.png',
                },
                {
                  caption: '・アクセシビリティ機能に対するアクセス要求\n※管理者権限が必要な操作があります。\n※インストール後の初回ログイン時のみ表示されます。\n下記のダイアログが表示されたら ”システム環境設定”を開く をクリックします。',
                  src: '/images/help/mac01/2.png',
                },
                {
                  caption: '左下の鍵のアイコンをクリックし、管理者のユーザー名とパスワードを入力してロックを解除します。',
                  src: '/images/help/mac01/3.png',
                },
                {
                  caption: 'リストに表示されている“RemoLaboAgent” にチェックを入れてください。',
                  src: '/images/help/mac01/4.png',
                },
                {
                  caption: 'インストール後の設定の手順は以上になります。',
                },
              ],
              subTitle: ' ※インストール後の設定（Mac版）',
              url: 'setting_after_install',
            },
            {
              thumbnail: [
                {
                  caption: 'トップバーから「ユーザー管理」画面を表示します。',
                  src: '/images/help/02_01.png',
                },
                {
                  caption: '「ユーザーを追加」ボタンより管理したいユーザーの情報を入力し、「コンピュータ」横の追加ボタンを押します。',
                  src: '/images/help/02_02.png',
                },
                {
                  caption: 'クライアントツールをインストールしたPCの情報が表示されるので、対象のパソコンを選び「決定」ボタンを押します。',
                  src: '/images/help/02_03.png',
                },
                {
                  caption: '「コンピュータ」セクションに先ほど追加したパソコンが表示されます。\n管理者側も同様に追加より管理するユーザーを追加します。',
                },
              ],
              subTitle: '２．ユーザーの関連付け',
            },
            {
              thumbnail: [
                {
                  caption: 'ユーザーの関連付けが行われると、ダッシュボード上のグラフが各種関連づいた情報を表示するようになります。',
                },
                {
                  caption: 'グラフ上の日付やメンバーを設定することで、登録したユーザーの情報が表示されます。',
                },
                {
                  caption: 'グラフはダッシュボードの「グラフを追加」＞「新規作成」ボタンより新たに作成することができ、作成したグラフは大きさ等を自由に変えることができます。',
                  src: '/images/help/03_01.png',
                },
              ],
              subTitle: '３．グラフでの確認',
              url: 'check_graph',
            },
          ],
        },
        {
          title: 'よくある質問',
          items: [
            {
              thumbnail: [
                {
                  caption: '・初期費用\n初期費用は0円です。月々の利用料金は110円(税込)/パソコン1台となっており、オプション等の追加料金なしで全ての機能をご利用いただけます。',
                },
                {
                  caption: '・最小契約数\n1台からの契約が可能です。',
                },
                {
                  caption: '・最小契約期間\n契約期間の制約等はございません。',
                },
                {
                  caption: '・システム条件\nWindows 8/10/11(64bitOSのみ)\nMacOS 10.14以降',
                },
                {
                  caption: '・動作環境\nブラウザは「Google Chrome」のご利用をお願いいたします。',
                },
                {
                  caption: '・ネットワーク条件\n現時点でVPNは不可となっており、通常の回線が必要となっております。',
                },
              ],
              subTitle: 'Q.導入条件について',
              url: 'conditions',
            },
            {
              thumbnail: [
                {
                  caption: '・クライアントツールのダウンロード時、不正のファイルとなる場合\nブラウザ下の継続を押しダウンロードしてください。',
                },
                {
                  caption: '・導入時、ノートンのチェックが入り「Setup.exe」が削除された場合\n下記手順をご参照いただき、ファイルの除外をお願いいたします。',
                },
                {
                  caption: '１． ノートンを起動し、［マイノートン］ウィンドウが開いたら［デバイスセキュリティ］の横にある［開く］をクリックします。',
                },
                {
                  caption: '２．［設定］をクリックします。',
                },
                {
                  caption: '３．［設定］ウィンドウで、［ウイルス対策］をクリックします。',
                },
                {
                  caption: '４．［スキャンとリスク］タブで、［自動保護、SONAR、ダウンロードインテリジェンスの検出から除外する項目］の横の［設定］をクリックします。',
                },
                {
                  caption: '５．［リアルタイム除外］ウィンドウで、［ファイルの追加］または［フォルダの追加］をクリックします。',
                },
                {
                  caption: '６．［項目の追加］ウィンドウで、ファイルまたはフォルダを参照して選択し、［OK］ボタンをクリックします。',
                },
                {
                  caption: '７．［適用］ボタン、［OK］ボタンの順にクリックします。',
                },
              ],
              subTitle: 'Q.導入時の不具合',
              url: 'defect',
            },
            {
              thumbnail: [
                {
                  caption: '・就業時間の登録方法\n「就業形態管理」画面左上の「就業形態を追加」をクリックします。全ての必須項目を入力し、「登録」をクリックすると就業時間の登録が完了します。',
                },
                {
                  caption: '・就業形態とユーザーの連携方法\n「ユーザー管理」画面から対象のユーザーを選択後「編集」ボタンをクリックし、作成した「就業形態」を選択してください。画面右上の「登録」ボタンをクリックすることで就業形態の設定が完了となります。',
                },
                {
                  caption: '・締め日の設定\n締め日を調整することにより、月毎のグラフで表示される期間を変更することができます。\n設定の際は「就業形態管理」画面から「勤怠締め日」をご確認ください。\n例)25日に設定すると26日から次月の判定となります。',
                },
              ],
              subTitle: 'Q.就業形態について',
            },
            {
              thumbnail: [
                {
                  caption: '・出勤の打刻方法\nRemoLaboでは操作開始時刻を自動的に記録し、マウス操作やキーボードの打鍵記録を基に勤務時間を自動で集計いたします。そのため手動で打刻をしていただく必要はございません。',
                },
                {
                  caption: '・勤務時間の算出方法\n15分間で、定められた特定の操作回数(キー入力数＋マウス操作回数)を達成することによって勤務時間が判定される仕組みとなっております。必要となる操作回数はユーザーごとの「職種」により異なります。',
                },
                {
                  caption: '・職種の設定方法\nユーザー管理画面の「基本情報」にある編集ボタンを押下し、編集画面で職種を設定します。',
                  src: '/images/help/q06_01.png',
                },
                {
                  caption: '・各職種の打鍵数\n一般職/600回\n事務・管理/150回\n営業/150回\n企画・マーケティング/150回\n経営・管理職/300回\nデザイナー/300回\nコンサルタント・士業/300回\nエンジニア・研究職/450回\n建築・土木技術職 /300回\n公務員/300回',
                },
              ],
              subTitle: 'Q.勤務時間の算出方法',
              url: 'calculation',
            },
                        {
              thumbnail: [
                {
                  caption: 'グループ機能は、設定したグループごとにグラフやログ内容を確認できる機能で、\nアカウント管理者、労務管理者のどちらの権限からも設定することができます。\n※設定されたグループは他ユーザーの画面で見ることはできません。\nグループ例：○○部、○○課、事務…等',
                },
                {
                  caption: '【設定方法】\nユーザー管理画面よりグループ名を設定してください。',
                  src: '/images/help/q08_01.png',
                },
                {
                  caption: 'ダッシュボードから「グラフを追加」＞「新規作成」で開くグラフ作成画面にて「グループ」を選択すると、グループごとの勤怠をご確認いただけます。',
                  src: '/images/help/q08_02.png',
                },
                {
                  caption: '作成したグラフをダッシュボードに追加すると、以下のようにグループごとに管理することができます。',
                  src: '/images/help/q08_03.png',
                },
              ],
              subTitle: 'Q.グループ機能について',
              url: 'group_function',
            },
            {
              thumbnail: [
                {
                  caption: '部署機能は、部署や所属するユーザーごとにグラフやログ内容を確認できる機能で、アカウント管理者が設定できます。 ',
                },
                {
                  caption: '【設定方法】 ユーザー管理画面より部署名を設定してください。\n作成した部署は他の労務管理者ユーザーからも参照できます。',
                  src: '/images/help/q11_01.png',
                },
                {
                  caption: 'ダッシュボードから「グラフを追加」＞「新規作成」で開くグラフ作成画面にて「部署」を選択すると、部署ごとの勤怠を確認できます。',
                  src: '/images/help/q11_02.png',
                },
                {
                  caption: '作成したグラフをダッシュボードに追加すると、以下のように部署ごとに管理することができます。',
                  src: '/images/help/q11_03.png',
                },
              ],
              subTitle: 'Q.部署機能について',
            },
            {
              thumbnail: [
                {
                  caption: 'RemoLaboでは、CSVを使ってユーザー、部署、データ関連付けを一括登録できます。\nCSVとは、登録したいデータをカンマ区切りで表現したフォーマットです(例：データA,データB,データC)。',
                },
                {
                  caption: '■CSVテンプレートのダウンロード\nトップバー「ユーザー管理」→「新規追加」→「CSVで追加」の順にボタンを押すと下の画面が開きます。\nCSVテンプレートの各ボタンから、CSVテンプレートファイルがダウンロードできます。',
                  src: '/images/help/q10_01.png',
                },
                {
                  caption: 'CSVテンプレートファイルを開くと、1行目にファイル種別、2行目にデータヘッダー、3行目以降に参考情報が記載されています。\n参考情報の内容を見ながらカンマ区切りでヘッダー順に情報を記述することで、CSVデータを作成できます。\n※参考情報はインポート前に削除してください。',
                },
                {
                  caption: '■インポート方法\n点線のエリアにCSVファイルを配置するとファイル名が表示されます。\nその後インポートボタンを押すとデータが読み込まれます。',
                  src: '/images/help/q10_02.png',
                },
                {
                  caption: 'インポート内容に問題がなければ「この内容でインポート」ボタンを押下します。\nエラーが表示された場合は、指示に従って修正して下さい。',
                  src: '/images/help/q10_03.png',
                },
              ],
              subTitle: 'Q.CSVインポートについて',
            },
             {
              thumbnail: [
                {
                  caption: 'アラート通知機能は、事前に設定した残業時間を超過したり、特定のサイトを閲覧したユーザーが通知される機能です。\n\n設定値に達したアラートは、操作の翌日午前6:00にニュース／アラート画面表示およびメールで通知されます。',
                },
                {
                  caption: '■36協定通知\n1日／1箇月／1年の時間外労働が設定値を超えると通知されます。\nアラートは職種ごとに設定でき、該当職種の設定されたユーザーのみがアラート対象となります。' +
                    'また、一般条項を超える値を特別条項に設定することにより、2段階でのアラートが可能になります。\n時間外労働は種類ごとに以下の時間となります。\n\n' +
                    '・所定労働時間外\n　　所定労働時間(※1)を超えた労働時間、休日の労働時間\n　　（フレックスタイム(※2)の場合、1ヶ月の労働時間合計から\n　　　1ヶ月の所定労働時間合計を引いた時間）\n' +
                    '・法定労働時間外\n　　1日8時間を超えた労働時間、週40時間を超えた労働時間、法定休日の労働時間\n　　（フレックスタイム(※2)の場合、1ヶ月の労働時間合計から\n　　　法定労働時間の総枠(※3)を引いた時間）\n\n' +
                    '※1 所定労働時間：始業から終業までの時間から休憩を引いた時間を指します\n' +
                    '※2 ユーザー管理画面でフレックスタイムが「あり」に設定されたユーザーが対象となり\n　　ます。またフレックスタイムのユーザーは1箇月・1年のアラートのみが有効と\n　　なりますので、1日のアラートを設定した場合、当該アラート通知は行われません。\n' +
                    '※3 法定労働時間の総枠：月の日数により以下となります\n　　・31日：177.1時間\n　　・30日：171.4時間\n　　・29日：165.7時間\n　　・28日：160.0時間\n',
                },
                {
                  caption: '■勤務間インターバル通知\n一定時間の間隔を開けずに勤務を開始すると通知されます。',
                },
                {
                  caption: '■禁止アプリの使用通知\n設定したアプリ、ウィンドウを開くと通知されます。',
                },
                {
                  caption: '【アラート通知設定方法】\nアラートはログイン後、画面右上の矢印から開くメニューの「アラート設定」から設定できます。',
                  src: '/images/help/q09_01.png',
                },
                {
                  caption: 'アラート通知はニュースページからご確認いただけます。',
                  src: '/images/help/q09_02.png',
                },
              ],
              subTitle: 'Q.アラート通知機能について',
              url: 'notification',
            },
            {
              thumbnail: [
                {
                  caption: '・操作ログの抽出方法\nダッシュボード画面左上にある「グラフを追加」ボタンをクリックし、CSVダウンロードグラフをダッシュボードに追加します。その後、対象のユーザーと日付を選択していただくとログの詳細表示やダウンロードができます。',
                },
                {
                  caption: '・CSVダウンロードでExcel変換する際に文字化けしてしまった場合\n文字化けはExcelの表示仕様の問題となっており、文字コードを変えて読み込む等の対処をすることで正常に表示されるようになります。下記の手順をお試しください。',
                },
                {
                  caption: '１．メモ帳でCSVファイルを開きます。',
                  src: '/images/help/q04_01.png',
                },
                {
                  caption: '２．メモ帳で文字化けせずに表示されていたら、ファイル→上書き保存をします。',
                  src: '/images/help/q04_02.png',
                },
                {
                  caption: 'ファイルの種類：すべてのファイル 文字コード(E) ：ANSI',
                  src: '/images/help/q04_03.png',
                },
                {
                  caption: '３．保存したデータをExcelのデータ→テキストまたはCSVからを選択し、先ほど保存したファイルをExcelで開きます。',
                  src: '/images/help/q04_04.png',
                },
                {
                  caption: '開いたデータが文字化けせずきちんと表示されていたら、データの変換ボタンをクリックします。',
                  src: '/images/help/q04_05.png',
                },
                {
                  caption: '４．閉じて読み込むを選択し、文字化けせずに表示されていることが確認できれば完了です。',
                },
              ],
              subTitle: 'Q.CSVログについて',
              url: 'csv_log',
            },
            {
              thumbnail: [
                {
                  caption: '・ご利用可能期間\nお試しプランは3ヵ月間無料でご利用いただけるプランです。\n例）6/15にご登録いただいた場合、9/30までお試しプラン期間とさせていただきます。',
                },
                {
                  caption: '・有料プランとの違い\n基本的には有料プランと同様の機能をご利用いただけますが、登録できるパソコン台数に上限がございます。お試しプランでは最大で200名までのユーザーが追加可能となっております。',
                },
                {
                  caption: '・お試しプラン中止の手続き方法\nクライアントツールをインストールいただいた端末から削除する事でご利用を中止していただけます。クライアントツールの削除については別ページ「クライアントツールの削除方法」をご覧ください。\n※有料プランへのお申込みをされずに3ヵ月が経過した際は、自動的にご利用を停止させていただきますのでご了承ください。',
                },
              ],
              subTitle: 'Q.お試しプランについて',
              url: 'free_experience',
            },
            {
              thumbnail: [
                {
                  caption: '・プラン料金\n料金は対象月の登録パソコン台数×110円（税込）となります。\n一度ユーザーのPCにクライアントツールをインストールされると、削除された場合も\n登録されていた月は課金の対象となりますのでご了承ください。',
                },
                {
                  caption: '・ユーザーの削除\n管理（課金）対象から特定のユーザーを外されたい場合、クライアントツールの削除をおこなっていただく必要がございます。\nクライアントツールの削除については別ページ「クライアントツールの削除方法」をご覧ください。',
                },
                {
                  caption: '・請求について\n有料プランをご利用いただいた月の末日に金額を算出し、翌月1日にHTMLメールによりご請求申し上げます。\n※お支払い期限は請求書メールを送付させていただく月の末日までとなっております。',
                },
                {
                  caption: '・お申込み方法\n「ご契約情報」画面から有料プランの「申し込む」ボタンをクリックし、「銀行振り込み」もしくは「クレジットカード」を選択してください。\n「銀行振り込み」をご利用の場合は、翌月1日に送付させていただくご請求メールにてお振込先を記載いたします。',
                  src: '/images/help/q06_02.png',
                },
              ],
              subTitle: 'Q.有料プランについて',
            },
            {
              thumbnail: [
                {
                  caption: '・毎月の適格請求書の取得について\n有料プランご利用の翌月1日にお送りするクレジット決済メール、銀行振込のご請求メールをインボイスとしてご使用いただけます。',
                },
                {
                  caption: '・過去の請求書取得について\n「ご契約情報」画面の「●適格請求書」より、2023年10月以降のご利用分の適格請求書を参照いただけます。\n最新の請求書は毎月1日（前月のご利用料金確定後）から表示可能になります。',
                  src: '/images/help/q12_01.png',
                },
                {
                  caption: '表示された適格請求書はブラウザの機能でプリントアウトまたはファイル保存してください。',
                  src: '/images/help/q12_02.png',
                },
              ],
              subTitle: 'Q.適格請求書（インボイス）について',
            },
            {
              thumbnail: [
                {
                  caption: '１．トップバーのユーザー名の右にある矢印をクリックし、「ご契約情報」画面を表示します。',
                },
                {
                  caption: '２．画面右下の「退会する」をクリックします。',
                  src: '/images/help/q05_01.png',
                },
                {
                  caption: '３．「退会につきまして」という画面が表示されますので、\n注意事項をご一読いただいた後「退会する」をクリックしてください。',
                  src: '/images/help/q05_02.png',
                },
                {
                  caption: '４．退会ボタンをクリック後、更新画面が表示されます。',
                  src: '/images/help/q05_03.png',
                },
                {
                  caption: '５．クライアントツールの削除をしていただくことで退会が完了となります。\n※削除方法については、別ページ「クライアントツールの削除方法」をご覧ください。',
                },
              ],
              subTitle: 'Q.有料プランの解約手順',
              url: 'cancellation',
            },
            {
              thumbnail: [
                {
                  caption: '１．Windowsの設定【プログラムの追加と削除】より「RemoLabo」と検索しアンインストールを選択します。',
                },
                {
                  caption: '２．アンインストール選択時に表示されるダイアログにて、ご契約情報画面のアンインストールパスワードを入力します。\n※アンインストール後にPCの再起動をお願いいたします。',
                  src: '/images/help/q07_01.png',
                },
              ],
              subTitle: 'Q.クライアントツールの削除方法（Windows版）',
              url: 'delete_client_win',
            },
            {
              thumbnail: [
                {
                  caption: '【Mojave_10.14】\n１．Finderを開き、「移動」メニューから「フォルダへ移動」を選択します。',
                  src: '/images/help/mac02/01.png',
                },
                {
                  caption: '２．「/ライブラリ」を入力して検索します。\n※先頭のスラッシュを忘れずに入力',
                  src: '/images/help/mac02/02.png',
                },
                {
                  caption: '３．ライブラリフォルダが表示されるので、右上の検索フォームに"RemoLaboUninstaller"と入力します。',
                  src: '/images/help/mac02/03.png',
                },
                {
                  caption: '４．「検索：」で「このMac」と「"ライブラリ"」が選択できるので、「"ライブラリ"」を選択します。しばらく待つと、RemoLaboUninstallerのアプリが表示されます。',
                  src: '/images/help/mac02/04.png',
                },
                {
                  caption: '５．RemoLaboUninstallerアプリのアイコンをダブルクリックすると、アンインストーラが起動します。以上で【Mojave_10.14】版のアンインストールが完了です。',
                  src: '/images/help/mac02/05.png',
                },
                {
                  caption: '\n\n【Catalina_10.15】\n１．右上の虫眼鏡アイコンをクリックします。',
                },
                {
                  caption: '２．Spotlight検索の入力フォームが表示されます。',
                  src: '/images/help/mac02/06.png',
                },
                {
                  caption: '３．"RemoLaboUninstaller" で検索すると、以下が表示されます。赤枠の行をダブルクリックすると、アンインストーラが起動します。',
                  src: '/images/help/mac02/07.png',
                },
                {
                  caption: '以上で【Catalina_10.15】版のアンインストールが完了です。',
                  src: '/images/help/mac02/08.png',
                },
              ],
              subTitle: 'Q.クライアントツールの削除方法（Mac版）',
            },
          ],
        },
      ],
      setModalData: {},
      modal: false,
      columnsCount: 0,
    };
  },
  async mounted() {
    this.changeWindowSize();
    window.addEventListener('resize', this.changeWindowSize);
  },
  methods: {
    openModal(data: any) {
      this.modal = !this.modal;
      this.setModalData = data;
    },
    changeWindowSize() {
      this.columnsCount = Math.floor(window.innerWidth / 400);
    },
    NumberOfColumns(list: any) {
      if (this.columnsCount) {
        return [...Array(list.length % this.columnsCount)].map((_, i) => i);
      }
    },
  },
  computed: {
    APP_MODE() { return NOC.APP.MODE; },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changeWindowSize);
  },
});
